import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { TextInput } from "components/DesignSystem/TextInput/TextInput";
import { FormikForm } from "components/FormikForm/FormikForm";
import { FormikValues } from "formik";
import { useToast } from "hooks/useToast";
import { useUpdateEntityMutation } from "store/apis/bookkeepingTracker";
import { BackendError } from "types/utils/error";
import { ModalProps } from "types/utils/modal";
import { object, string } from "yup";

export const EditEntityName = ({
  isOpen,
  close,
  entityName,
  groupId,
  entityId,
  setFieldValue,
}: ModalProps & {
  entityName: string;
  groupId: string;
  entityId: string;
  setFieldValue: (name: string, value: any) => void;
}) => {
  const { alertToast, successToast } = useToast();
  const [updateEntity, { isLoading }] = useUpdateEntityMutation();

  const onSubmit = async (values: FormikValues) => {
    try {
      await updateEntity({
        groupId,
        entityId,
        name: values.name,
      }).unwrap();
      setFieldValue("entity_name", values.name);
      successToast({ message: "Entity name updated successfully" });
      close();
    } catch (error) {
      alertToast({ message: (error as BackendError)?.data?.error?.message });
    }
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content asChild>
        <FormikForm
          initialValues={{
            name: entityName || "",
          }}
          validationSchema={object({
            name: string().required("Name is required"),
          })}
          validateOnChange
          onSubmit={onSubmit}
        >
          {({ submitForm, dirty }) => (
            <>
              <Modal.Header>
                <Modal.Title>Edit Entity Name</Modal.Title>
                <Modal.Close />
              </Modal.Header>
              <Modal.Body>
                <TextInput
                  name="name"
                  required
                  label="Name"
                  customType="warning"
                  placeholder="Entity name"
                  note="Change applies across the platform and to future
                      documents. Past filings and PDFs remain unchanged."
                />
              </Modal.Body>
              <Modal.FooterButtonGroup>
                <Modal.RawClose asChild>
                  <Button>Cancel</Button>
                </Modal.RawClose>
                <Button
                  disabled={!dirty || isLoading}
                  isLoading={isLoading}
                  onClick={submitForm}
                  customType="primary"
                >
                  Save
                </Button>
              </Modal.FooterButtonGroup>
            </>
          )}
        </FormikForm>
      </Modal.Content>
    </Modal.Root>
  );
};
